var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "menu-item__inner"
  }, [_vm.icon ? _c("svg-icon", {
    staticClass: "menu-item__icon",
    attrs: {
      "icon-class": _vm.icon
    }
  }) : _vm._e(), _vm.title ? _c("span", {
    staticClass: "menu-item__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };